const HomeIcon = () => {
    return <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        data-testid="flowbite-sidebar-item-icon" className="h-6 w-6 flex-shrink-0 transition duration-75 group-hover:text-gray-900 dark:group-hover:text-white text-gray-700 dark:text-gray-100"><path d="M12.848 2.752a1.2 1.2 0 00-1.696 0l-8.4 8.4a1.2 1.2 0 001.696 1.696l.352-.351V20.4A1.2 1.2 0 006 21.6h2.4a1.2 1.2 0 001.2-1.2V18a1.2 1.2 0 011.2-1.2h2.4a1.2 1.2 0 011.2 1.2v2.4a1.2 1.2 0 001.2 1.2H18a1.2 1.2 0 001.2-1.2v-7.903l.352.351a1.2 1.2 0 001.696-1.696l-8.4-8.4z"
            fill="#9CA3AF"></path></svg>

}

export default HomeIcon;